var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-scroll-container"},[_c('div',{staticClass:"chart-container",style:([
      {
        position: 'relative',
        height: '400px',
        width: _vm.chartWidth,
      },
    ])},[_c('canvas',{ref:"chart",staticStyle:{"max-width":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }